export const COLOR_CLASSES = {
  purple: 'bg-tog-light-purple',
  green: 'bg-tog-light-green',
  blue: 'bg-tog-light-blue-shaded',
  yellow: 'bg-tog-light-yellow',
  pink: 'bg-tog-light-pink',
  orange: 'bg-tog-light-orange',
  teal: 'bg-tog-teal text-white',
  brown: 'bg-tog-light-brown',
  gray: 'bg-tog-light-gray',
};

export const EXPORT_COLOR_RULES = {
  'Non-EU': 'bg-tog-orange',
  EU: 'bg-tog-red',
  AU: 'bg-tog-yellow',
  SA: 'bg-tog-maroon text-white',
  UK: 'bg-tog-light-blue-shaded',
  default: 'bg-tog-light-blue-shaded',
};

export const COLUMNS_TO_SHADE = ['sire', 'donorName', 'semenType'];
